<template>
  <el-dialog top="30vh" class="tip-dialog" :visible="visible" :close-on-click-modal="true" center>
    <img class="yes-match-c" :src="require('@/assets/img/dialog/yes-match-c.png')" />
    <img class="yes-match-t" :src="require('@/assets/img/dialog/yes-match-t.png')" />
    <img class="yes-match-g1" :src="require('@/assets/img/dialog/yes-match-g1.png')" />
    <img class="yes-match-g2" :src="require('@/assets/img/dialog/yes-match-g2.png')" />
    <img class="multi-win" :src="require('@/assets/img/dialog/multi-win.png')" />
    <div class="multi-win-text">{{ data.continue_win }}连胜</div>
    <div class="content flex-column flex-middle">
      <div class="content-res">已猜中：</div>
      <div class="content-title">{{ data.title }}</div>
      <div class="content-body">答案：{{ data.answer }}</div>
      <div class="btn flex-middle" @click="close">我知道了</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    /*
			title:{
				type: String,
				default: "主队能获得胜利吗？"
			},
			content:{
				type: String,
				default: "答案：能"
			},
			*/
  },
  data() {
    return {
      visible: false,
      data: {},
    };
  },
  methods: {
    open(data = {}) {
      this.visible = true;
      this.data = data;
      // setTimeout(() => {
      //   this.data = {};
      //   this.visible = false;
      // }, 2500);
      console.log("data: ", data);
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog {
    // background: transparent;
    position: relative;
    background-color: #ffffff;
    background-image: url("../../assets/img/dialog/yes-match-k.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 3.35rem;
    height: 2.2rem;
    border-radius: 18px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.tip-dialog {
  .yes-match-t {
    width: 50%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -100%);
    z-index: 10;
  }
  .yes-match-c {
    width: 90%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -60%);
    z-index: 20;
  }
  .yes-match-g1 {
    width: 96%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  .yes-match-g2 {
    width: 96%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .multi-win {
    width: 0.6rem;
    position: absolute;
    top: -0.4rem;
    right: -0.12rem;
  }
  .multi-win-text {
    position: absolute;
    top: 0.35rem;
    right: 0px;
    color: #ffffff;
  }
  .content {
    height: 100%;
    padding: 0.2rem 0.2rem;
    padding-top: 0.3rem;
    color: #333333;
    font-size: 0.18rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .content-res,
    .content-title {
      color: #333333;
      line-height: 0.25rem;
      font-size: 0.15rem;
    }
    .content-body {
      color: #ff6200;
      line-height: 0.4rem;
      font-size: 0.18rem;
      margin: 0.2rem 0 0.1rem;
    }
    .btn {
      width: 1.16rem;
      height: 0.34rem;
      background: linear-gradient(89.96deg, #ffd600 1.12%, #ff9400 98.62%);
      border-radius: 5px;
      color: #ffffff;
      font-size: 0.14rem;
      cursor: pointer;
      z-index: 1;
    }
  }
}
</style>
